<script>
import { library } from "@common/library/library";
import { componentStore } from "@common/componentStore/componentStore";

let navigationPageConfig = {
    cId: "navigationPage",
    cType: "navigationPage",
    cTitle: "iFrame Page",
    cTemplate: `<div class="iframe-wrapper">
                    <iframe
                        v-if="false"
                        :src="src"
                        :id="id"
                        :name="name"
                        @load="localOnFrameLoad"
                        :class="cssClass"
                        vspace="0" hspace="0"
                    ></iframe>
                </div>
               `,
    controls: []
};

const editorConfig = {};

const navigationPageCmp = {
    name: 'navigationPage',
    editorSettings: editorConfig,
    props: {
        src: {
            default: false
        },
        id: {
            default: false
        },
        name: {
            default: false
        },
        cssClass: {
            default: false
        },
        onFrameLoad: {
            default: false
        }
    },
    data() {
        return {};
    },
    methods: {
        localOnFrameLoad(tmpEvent) {
            if (typeof this.onFrameLoad === 'function') {
                this.onFrameLoad(tmpEvent);
            }
        },
    }
};

componentStore.initComponent(navigationPageCmp, navigationPageConfig, '@common/navigation/navigationPage.vue');
export { navigationPageConfig, navigationPageCmp };
export default navigationPageCmp;
</script>

<style scoped>
.iframe-wrapper {
    width: 100%;
}
</style>
